import React from "react";
// import {Router, hashHistory} from "react-router";
import {
  HashRouter
} from "react-router-dom";

import MainIndexComponent from "./bvcomponents";
// import qkbRoutes from "./qkbRoutes";
import {fixVisualizerType} from "./misc/visualizerSwitchingFunctions";
import {
  hardCodeIsAmericanStandard,
  hardCodeIsAmericanImport,
  hardCodeIsCaesarStone,
  hardCodeIsModerno,
  hardCodeIsLowes,
  hardCodeIsNhance, hardCodeIsRebath, hardCodeIsNFM, hardCodeIsStoneSystems
} from "./misc/fabricatorHardcode";
import {getMainThemeFromCSS, runSalesForceLogic} from "./loadingLogic";
import {setAsComplexLogic} from "./misc/complexLogic";
import {IS_OFFLINE_MODE, USE_NEW_CANVAS} from "./config";
import {deregisterServiceWorker} from "./misc/offlineImagesCache";
import {onBeforeUnload} from "./misc/misc2";

runSalesForceLogic();
if (!IS_OFFLINE_MODE) {
  deregisterServiceWorker();
}

//window.postMessage({name: "quoteCountertops.canvasLoadEvent"});

export default class App extends React.Component {

  constructor(props) {
    super(props);
    // switch (document.kvConfig.userId) {
    //   case 139864:
    //   case 142022:
    //     document.kvConfig.visualizerType = "kvMaster";
    //     break;
    //   case 140028:
    //   case 140029:
    //     document.kvConfig.visualizerType = "kvScene";
    //     document.kvConfig.layersSize = "full_hd";
    //     break;
    //   case 140031:
    //   case 152152:
    //   case 140036: // https://bathroom_8k_2.quotesflooring.com/visualizer#/
    //   case 154840: // https://american_import_brv5.quotekitchenandbath.com/visualizer#/
    //     document.kvConfig.visualizerType = "bvScene";
    //     document.kvConfig.layersSize = "full_hd";
    //     break;
    //   default:
    //     break;
    // }

    fixVisualizerType();

    // changing styles also require changes in serverReducer.js
    const theme = getMainThemeFromCSS();
    if (theme) {
      document.body.classList.remove('theme-qc');
      document.body.classList.add('theme-' + theme);
    } else {
      if (hardCodeIsCaesarStone()) {
        document.body.classList.remove('theme-qc');
        document.body.classList.add('theme-caes');
      } else if (hardCodeIsAmericanImport()) {
        document.body.classList.remove('theme-qc');
        document.body.classList.add('theme-as-5');
      } else if (hardCodeIsAmericanStandard() || hardCodeIsRebath() || hardCodeIsStoneSystems()) {
        document.body.classList.remove('theme-qc');
        document.body.classList.add('theme-as');
      } else if (hardCodeIsModerno() || hardCodeIsNFM()) {
        document.body.classList.remove('theme-qc');
        document.body.classList.add('theme-moderno');
      } else if (hardCodeIsLowes()) {
        document.body.classList.add('bv--lowes');
      } else if (hardCodeIsNhance()) {
        document.body.classList.add('theme-nhance');
      }
    }
    if (USE_NEW_CANVAS) {
      document.body.classList.add('bv--rzpp');
    }
    if (hardCodeIsAmericanStandard()) {
      setAsComplexLogic();
    }
    // console.log('document.kvConfig.visualizerType: ', document.kvConfig.visualizerType);
    // console.log('document.kvConfig.navigationType: ', document.kvConfig.navigationType);
    if (!document.kvConfig.isBackend) {
      document.kvConfig.isBackend = window.location.href.includes("mode=dashboard");
    }
    document.bvConfig = {
      "showPlaceholders": document.kvConfig.visualizerType === "BV" || document.kvConfig.visualizerType === "Bathroom",
    };

    window.addEventListener('beforeunload', onBeforeUnload);
  }

  render() {

    // if (IS_QKB_UI) {
    //   return (
    //     <Router history={hashHistory}>
    //       {qkbRoutes}
    //     </Router>
    //   );
    // }

    return (
      <HashRouter>
        <MainIndexComponent/>
      </HashRouter>
    );
  }
}
